"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tokenizer = void 0;
var NfaState_1 = require("./NfaState");
var Nfa_1 = require("./Nfa");
var DfaState_1 = require("./DfaState");
var CharMatcher_1 = require("./CharMatcher");
var RangeMatcher_1 = require("./RangeMatcher");
var Token_1 = require("./Token");
/** @constructor */
var Tokenizer = /** @class */ (function () {
    //   dbg: IDebugConsole;
    function Tokenizer(dbg) {
        this.dbg = dbg;
        this.root = new NfaState_1.NfaState();
        this.index = 0;
        this.listId = 1;
        this.dfaCache = {};
        // text to tokenize.
        this.text = '';
        // for each line, the character position of that line in the text.
        this.lineNumbers = [];
        // users can redefine these if they want.
        this.EOF_TOKEN = {};
        this.IGNORE_TOKEN = {};
        // check this to determine if we have reached the end of the text.
        /*private*/ this.finished = true;
    }
    Tokenizer.prototype.addToken = function (id, expr) {
        this.expr = expr;
        this.index = 0;
        var nfa = this.parseAlternation();
        this.root.next.push(nfa.start);
        nfa.end.accept = id;
    };
    Tokenizer.prototype.ignore = function (expr) {
        this.addToken(this.IGNORE_TOKEN, expr);
    };
    Tokenizer.prototype.eof = function () {
        return this.index == this.expr.length;
    };
    Tokenizer.prototype.matchChar = function (ch) {
        if (this.expr[this.index] == ch) {
            this.index++;
            return true;
        }
        return false;
    };
    Tokenizer.prototype.peek = function (ch) {
        return this.expr[this.index] == ch;
    };
    Tokenizer.prototype.parseChar = function () {
        if (this.matchChar('\\')) {
            if (this.matchChar('n')) {
                return '\n';
            }
            else if (this.matchChar('r')) {
                return '\r';
            }
            else if (this.matchChar('t')) {
                return '\t';
            }
            else if (this.matchChar('d')) {
                return CharMatcher_1.DIGIT_CHAR;
            }
            else {
                return this.expr[this.index++];
            }
        }
        else if (this.matchChar('.')) {
            return CharMatcher_1.ANY_CHAR;
        }
        else if (this.matchChar('$')) {
            return CharMatcher_1.PRE_NEWLINE;
        }
        else if (this.matchChar('^')) {
            return CharMatcher_1.POST_NEWLINE;
        }
        else {
            return this.expr[this.index++];
        }
    };
    Tokenizer.prototype.parseRange = function () {
        var include = true;
        var ranges = [];
        while (!this.eof() && !this.peek(']')) {
            if (this.matchChar('^')) {
                include = false;
            }
            var first = this.parseChar();
            var last = first;
            if (this.matchChar('-')) {
                last = this.parseChar();
            }
            if (first == CharMatcher_1.DIGIT_CHAR) {
                first = '0';
                last = '9';
            }
            //dbg.printf("Pushing range %s..%s\n", first, last );
            ranges.push([first, last]);
        }
        var state = new NfaState_1.NfaState(new RangeMatcher_1.RangeMatcher(ranges, include));
        return new Nfa_1.NFA(state, state);
    };
    Tokenizer.prototype.parseBasic = function () {
        var nfa;
        if (this.matchChar('(')) {
            nfa = this.parseAlternation();
            if (!this.matchChar(')')) {
                throw "Expected ')'";
            }
        }
        else if (this.matchChar('[')) {
            //dbg.printf("Encountered RANGE!\n");
            nfa = this.parseRange();
            if (!this.matchChar(']')) {
                throw "Expected ']'";
            }
        }
        else {
            var state = new NfaState_1.NfaState(new CharMatcher_1.CharMatcher(this.parseChar()));
            nfa = new Nfa_1.NFA(state, state);
        }
        return nfa;
    };
    Tokenizer.prototype.parseKleene = function () {
        var nfa = this.parseBasic();
        // var splitter;
        if (this.matchChar('+')) {
            var splitter = new NfaState_1.NfaState();
            nfa.end.next.push(splitter);
            splitter.next.push(nfa.start);
            nfa.end = splitter;
        }
        else if (this.matchChar('*')) {
            var splitter = new NfaState_1.NfaState();
            splitter.next.push(nfa.start);
            nfa.end.next.push(splitter);
            nfa.start = splitter;
            nfa.end = splitter;
        }
        else if (this.matchChar('?')) {
            var start = new NfaState_1.NfaState();
            var end = new NfaState_1.NfaState();
            start.next.push(nfa.start);
            start.next.push(end);
            nfa.end.next.push(end);
            nfa.start = start;
            nfa.end = end;
        }
        return nfa;
    };
    Tokenizer.prototype.parseConcat = function () {
        var start = new NfaState_1.NfaState();
        var end = start;
        for (;;) {
            if (this.peek('|') || this.peek(')') || this.eof()) {
                break;
            }
            var nfa = this.parseKleene();
            end.next.push(nfa.start);
            end = nfa.end;
        }
        return new Nfa_1.NFA(start, end);
    };
    Tokenizer.prototype.parseAlternation = function () {
        var start = new NfaState_1.NfaState();
        var end = new NfaState_1.NfaState();
        do {
            var nfa = this.parseConcat();
            start.next.push(nfa.start);
            nfa.end.next.push(end);
        } while (this.matchChar('|'));
        return new Nfa_1.NFA(start, end);
    };
    Tokenizer.prototype.addState = function (nfaStateList, accepts, nfaState) {
        if (nfaState.lastList == this.listId) {
            //dbg.printf("Skip adding nfa State [%d]\n", nfaState.id );
            return;
        }
        //dbg.printf("Add NFA state [%d]\n", nfaState.id );
        if (nfaState.accept !== undefined) {
            accepts.push(nfaState.accept);
        }
        nfaState.lastList = this.listId;
        nfaStateList.push(nfaState);
        if (nfaState.mchar === undefined) {
            for (var i = 0; i < nfaState.next.length; i++) {
                this.addState(nfaStateList, accepts, nfaState.next[i]);
            }
        }
    };
    Tokenizer.prototype.nextState = function (dfaState, ch) {
        var nfaStateList = [];
        var accepts = [];
        var i;
        //dbg.printf("Transition from DFA[%d] on ch=%s\n", dfaState.id, ch );
        this.listId++;
        for (i = 0; i < dfaState.nfaStates.length; i++) {
            var nfaState = dfaState.nfaStates[i];
            if (nfaState.mchar !== undefined) {
                if (nfaState.mchar.match(ch)) {
                    this.addState(nfaStateList, accepts, nfaState.next[0]);
                }
                else if (ch == CharMatcher_1.PRE_NEWLINE || ch == CharMatcher_1.POST_NEWLINE) {
                    this.addState(nfaStateList, accepts, nfaState);
                }
            }
        }
        nfaStateList.sort(function (a, b) {
            return a.id - b.id;
        });
        var key = '';
        for (i = 0; i < nfaStateList.length; i++) {
            key += nfaStateList[i].id + '.';
        }
        if (this.dfaCache[key] === undefined) {
            dfaState = new DfaState_1.DfaState();
            //dbg.printf("Created DFA state [%d] accepts=%s\n", dfaState.id, accepts );
            dfaState.nfaStates = nfaStateList;
            dfaState.accepts = accepts;
            this.dfaCache[key] = dfaState;
        }
        else {
            //dbg.printf("Returning cached DFA state [%d] accepts=%s\n",
            //        this.dfaCache[key].id, this.dfaCache[key].accepts );
        }
        return this.dfaCache[key];
    };
    Tokenizer.prototype.setText = function (text) {
        this.text = text;
        this.lineNumbers.length = 0;
        this.lineNumbers.push(0);
        this.finished = false;
        for (var i = 0; i < this.text.length; i++) {
            if (this.text[i] == '\n') {
                this.lineNumbers.push(i + 1);
            }
        }
    };
    Tokenizer.prototype.getLine = function (lineno) {
        return this.text.substr(this.lineNumbers[lineno], this.lineNumbers[lineno + 1] - this.lineNumbers[lineno]);
    };
    /**
          Retrieve a list of tokens that match at a given position. The list is
          returned sorted in order of length.
  
          @param text Text to match.
          @param line Line number to begin matching, starting from 0
          @param position Character position on the line to begin matching.
      */
    Tokenizer.prototype.nextTokenInternal = function (line, position) {
        var dbg = this.dbg;
        //var last = 0;
        var last = 0;
        var i;
        var accept = null;
        if (this.rootDfa === undefined) {
            this.rootDfa = new DfaState_1.DfaState();
            this.addState(this.rootDfa.nfaStates, this.rootDfa.accepts, this.root);
        }
        var dfaState = this.rootDfa;
        var startPosition = this.lineNumbers[line] + position;
        //dbg.printf("Start match from %d:%d\n", line, position );
        if (startPosition == this.text.length) {
            this.finished = true;
            return new Token_1.Token(this.EOF_TOKEN, '!EOF', line, position);
        }
        if (startPosition > 0) {
            last = this.text[startPosition - 1];
        }
        for (i = startPosition; i < this.text.length; i++) {
            //dbg.printf("Enter DFA state %d\n", dfaState.id );
            var ch = this.text[i];
            if (ch === '\n' && last != CharMatcher_1.PRE_NEWLINE) {
                ch = CharMatcher_1.PRE_NEWLINE;
                i--;
            }
            else if (last === '\n' || last === 0) {
                ch = CharMatcher_1.POST_NEWLINE;
                i--;
            }
            if (last === '\n') {
                line++;
            }
            last = ch;
            if (dfaState.next[ch] === undefined) {
                dfaState.next[ch] = this.nextState(dfaState, ch);
            }
            dfaState = dfaState.next[ch];
            if (dfaState.accepts.length) {
                //dbg.printf("Would accept %s\n", dfaState.accepts[0] );
                //dbg.printf("i:%d line:%d lineNumbers=%d\n",
                //    i, line, this.lineNumbers[line] );
                accept = new Token_1.Token(dfaState.accepts[0], this.text.substr(startPosition, i - startPosition + 1), line, startPosition - this.lineNumbers[line]);
            }
            if (dfaState.nfaStates.length === 0) {
                break;
            }
        }
        if (accept) {
            //dbg.printf("Returning match id=%s at %d:%d text=%s\n", accept.id,
            //    accept.locus.line, accept.locus.position, accept.text );
        }
        else if (0) {
            // dbg.printf("Bad token at '%s'\n", this.text.substr(startPosition, 10));
            dbg.print("Bad token at " + this.text.substr(startPosition, 10) + "\n");
            // dbg.printf('ascii %d\n', this.text.charCodeAt(startPosition));
            dbg.print("ascii " + this.text.charCodeAt(startPosition) + "\n");
        }
        return accept;
    };
    Tokenizer.prototype.nextToken = function (line, position) {
        for (;;) {
            var token = this.nextTokenInternal(line, position);
            if (token === null || token.id !== this.IGNORE_TOKEN) {
                return token;
            }
            line = token.location.line;
            position = token.location.position + token.text.length;
        }
    };
    return Tokenizer;
}());
exports.Tokenizer = Tokenizer;
//# sourceMappingURL=Tokenizer.js.map